// src/client/useAwaitableNavigate.tsx
import React from "react";
import { useLocation, useNavigate } from "react-router";
var useAwaitableNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const resolveFunctionsRef = React.useRef([]);
  const resolveAll = () => {
    resolveFunctionsRef.current.forEach((resolve) => resolve());
    resolveFunctionsRef.current.splice(0, resolveFunctionsRef.current.length);
  };
  React.useEffect(() => {
    resolveAll();
  }, [location]);
  return (to, opts) => {
    return new Promise((res) => {
      resolveFunctionsRef.current.push(res);
      void navigate(to, opts);
    });
  };
};
export {
  useAwaitableNavigate
};
//# sourceMappingURL=useAwaitableNavigate.js.map